<template>
  <div
    class="p-15 pt-10 absolute z-9999 shadow-dropdown rounded-4 text-14 leading-normal text-app-color"
    :class="isDarkMode ? 'bg-sidebar' : 'bg-white'"
    :style="commentPosition"
    @click.stop
    @keydown.backspace.stop
  >
    <p class="text-16 font-bold">{{ userName }}</p>
    <textarea
      ref="commentInputRef"
      v-model="localComment"
      class="outline-none w-240 bg-transparent text-app-color mt-10 "
      maxlength="255"
      rows="2"
      placeholder="Type here..."
      @keydown.esc="hideComment"
      @keydown.enter.exact.prevent.stop="setComment"
      @keydown.backspace.stop
      @paste.stop
    />
    <div class="flex justify-end items-center mt-10">
      <ButtonModule
        text="Cancel"
        :has-hover="true"
        class="text-app-color text-14 mr-12"
        @click="hideComment"
      />
      <ButtonModule
        text="Comment"
        class="bg-link-color rounded-4 py-8 px-12 text-white text-14 hover:opacity-90 ease-in-out"
        @click="setComment"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, computed } from 'vue'

import ButtonModule from '@/components/shared/form-controls/ButtonModule'
import { useStore } from 'vuex'

export default defineComponent({
  components: { ButtonModule },

  props: {
    commentPosition: [String, Object],
    commentId: Number
  },

  emits: ['setComment', 'hideComment'],

  setup (props, { emit }) {
    const { state, getters } = useStore()

    const localComment = ref('')
    const commentInputRef = ref(null)

    const project = computed(() => state.project.currentProject)
    const user = computed(() => state.profile.user)
    const isDarkMode = computed(() => getters.isDarkMode)
    const userName = computed(() => user.value?.profile.firstName || 'Guest')

    const comment = project.value.comments.find(item => item.id === props.commentId)
    localComment.value = comment?.body

    function setComment () {
      emit('setComment', localComment.value)
      localComment.value = ''
    }

    function hideComment () {
      localComment.value = ''
      emit('hideComment')
    }

    function setFocus () {
      commentInputRef.value.focus()
    }

    return {
      // ref
      commentInputRef,
      localComment,
      // computed
      isDarkMode,
      userName,
      // function
      setComment,
      hideComment,
      setFocus
    }
  }
})
</script>
